import {
  USQCPPage,
  UKQCPPage,
  ReferralPage,
  AgentReferralPage,
  QuestionnairePage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
  ExplanationPage,
  PhoneNumberPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "../packs/components/DevTools";

export const pageComponents = {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  ExplanationPage,
  PhoneNumberPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
};

export const utilityComponents = {
  DevTools,
};
